import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { toJS } from "mobx";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

// Extend Day.js with custom format parsing
dayjs.extend(customParseFormat);

export const useMealNextAvailableDate = (meals = []) => {
  if (!Array.isArray(meals) || meals.length === 0) return null;

  const now = dayjs();

  for (let i = 0; i < meals.length; i++) {
    const { meal_date, target_time } = meals[i] || {};

    if (!meal_date || !target_time) continue;

    const timePart = target_time; // Already a clean "HH:mm:ss" string
    const combinedString = `${meal_date} ${timePart}`;

    const targetDateTime = dayjs(combinedString, "YYYY-MM-DD HH:mm:ss");

    if (!targetDateTime.isValid()) {
      console.warn("Invalid datetime:", combinedString);
      continue;
    }

    const diffInHours = targetDateTime.diff(now, "hour", true);

    if (diffInHours >= 16) {
      return {
        mealDate: meal_date,
        targetTime: timePart,
        diffInHours: Number(diffInHours.toFixed(2)),
        isLessThan16: false,
        index: i,
      };
    }
  }

  return null;
};

export const getValidMealList = (meals = []) => {
  const _meals = toJS(meals);
  const now = dayjs();
  if (!Array.isArray(_meals)) return [];

  return _meals.filter(({ meal_date, target_time }) => {
    if (!meal_date || !target_time) return false;

    const combinedString = `${meal_date} ${target_time}`;
    const targetDateTime = dayjs(combinedString, "YYYY-MM-DD HH:mm:ss");

    if (!targetDateTime.isValid()) return false;

    const diffInHours = targetDateTime.diff(now, "hour", true);
    return diffInHours >= 16;
  });
};

export const useMealNextAvailableDateForSubsidy = (meals = []) => {
  if (!Array.isArray(meals) || meals.length === 0) return null;

  const now = dayjs();
  let weekOffset = 1;

  while (weekOffset <= 52) {
    const startOfNextWeek = now
      .add(weekOffset, "week")
      .startOf("week")
      .add(1, "day");
    const endOfNextWeek = startOfNextWeek.add(6, "day");

    for (let i = 0; i < meals.length; i++) {
      const { meal_date, restaurants_published } = meals[i] || {};
      if (!meal_date || typeof restaurants_published !== "boolean") continue;

      const date = dayjs(meal_date, "YYYY-MM-DD");
      if (!date.isValid()) continue;

      const isInTargetWeek =
        date.isSameOrAfter(startOfNextWeek, "day") &&
        date.isSameOrBefore(endOfNextWeek, "day");

      if (isInTargetWeek && restaurants_published === false) {
        return {
          mealDate: meal_date,
          index: i,
        };
      }
    }

    weekOffset += 1;
  }

  return null;
};

export const getValidMealListForSubsidy = (meals = []) => {
  const _meals = toJS(meals);
  if (!Array.isArray(_meals)) return [];

  const now = dayjs();

  const startOfNextWeek = now.add(1, "week").startOf("week").add(1, "day");
  const endOfNextWeek = startOfNextWeek.add(6, "day");

  return _meals.filter(({ meal_date, restaurants_published }) => {
    if (!meal_date || typeof restaurants_published !== "boolean") return false;

    const date = dayjs(meal_date, "YYYY-MM-DD");
    if (!date.isValid()) return false;

    const isInNextWeek =
      date.isSameOrAfter(startOfNextWeek, "day") &&
      date.isSameOrBefore(endOfNextWeek, "day");

    return isInNextWeek && restaurants_published === false;
  });
};
